import React, { useState } from 'react';

import RegistrationForm from '../shared/RegistrationForm';

import './FormSection.scss';

const FormSection = () => {
  const [formStatus, setFormStatus] = useState('');

  return (
    <section id="contact-us" className="form-section">
      <div className="form-section__content max-w-[75.5rem] lg:flex-col lg:gap-6">
        {formStatus !== 'success' && (
          <div className="w-[40%] lg:w-full">
            <h2 className="font-Proxima text-[3rem] font-black uppercase leading-[1.16] text-white lg:text-[36px] sm:text-[2rem]">
              Let’s work <br />
              <span className="text-demo-sa-green">together</span>
            </h2>
          </div>
        )}

        <div className="form-section__form-container">
          {formStatus !== 'success' && (
            <div className="mb-6 flex flex-col gap-4">
              <h3 className="gl-heading-3 text-white">Request a demo</h3>
              <div className="text-white">
                <p>
                  Would you like to learn how the Gen AI Retail Shopping Assistant can assist in meeting your goals?
                </p>
                <p className="mt-5">Fill in the form below. We’ll get back to you.</p>
              </div>
            </div>
          )}
          <RegistrationForm updateFormStatus={setFormStatus} />
        </div>
      </div>
    </section>
  );
};

export default FormSection;
